<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Upload  :action="importCompany">
					<Button icon="ios-cloud-upload-outline">批量导入岗位</Button>
				</Upload>
				<a @click="importTemplate" style="margin-left: 20px;">下载导入模板</a>
				<Button type="success" @click="exportExcel" icon="ios-cloud-download-outline"
									style="margin-left: 20px;">导出兼职猫全部岗位</Button>
			</TableFuncs>
			<QueryCondition @query="query" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120">

				<FormItem label="城市" prop="city">
					<Input v-model="addForm.city" maxlength="10" placeholder="请输入城市名称"></Input>
				</FormItem>
				<FormItem label="岗位名称" prop="title">
					<Input v-model="addForm.title" maxlength="100" placeholder="请输入岗位名称"></Input>
				</FormItem>
				<FormItem label="数据类型">
					<Input v-model="addForm.dataType" maxlength="50" placeholder="请输入数据类型"></Input>
				</FormItem>
				<FormItem label="岗位类型" prop="jobTag">
					<Input v-model="addForm.jobTag" maxlength="50" placeholder="请输入岗位类型"></Input>
				</FormItem>
				<FormItem label="推荐类型">
					<Input v-model="addForm.recommendType" maxlength="500" placeholder="请输入推荐类型"></Input>
				</FormItem>
				<FormItem label="岗位描述" prop="jobDesc">
					<Input type="textarea" v-model="addForm.jobDesc" maxlength="1000" placeholder="请输入岗位描述"></Input>
				</FormItem>
				<FormItem label="岗位要求" prop="jobLimit">
					<Input type="textarea" v-model="addForm.jobLimit" maxlength="255" placeholder="请输入岗位要求"></Input>
				</FormItem>
				<FormItem label="学历要求" prop="education">
					<Input v-model="addForm.education" maxlength="10" placeholder="请输入学历要求"></Input>
				</FormItem>
				<FormItem label="公司名称" prop="company">
					<Input v-model="addForm.company" maxlength="100" placeholder="请输入公司名称"></Input>
				</FormItem>
				<FormItem label="企业类型" prop="companyType">
					<Input v-model="addForm.companyType" maxlength="50" placeholder="请输入企业类型"></Input>
				</FormItem>

				<FormItem label="薪资" prop="salary">
					<Input v-model="addForm.salary" placeholder="请输入薪资"></Input>
				</FormItem>
				<FormItem label="工作场景" prop="scene">
					<RadioGroup v-model="addForm.scene">
						<Radio :label="1">线上</Radio>
						<Radio :label="2">线下</Radio>
						<Radio :label="3">线上|线下</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="工作属性" prop="attr">
					<RadioGroup v-model="addForm.attr">
						<Radio :label="1">兼职</Radio>
						<Radio :label="2">实习</Radio>
						<Radio :label="3">不限</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="结算方式" prop="settleType">
					<RadioGroup v-model="addForm.settleType">
						<Radio :label="1">日结</Radio>
						<Radio :label="2">周结</Radio>
						<Radio :label="3">月结</Radio>
						<Radio :label="4">完结</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="包名二维码" prop="codeUrl">
					<Upload :action="uploadFile" name="file" :on-success="codeImgBack" :default-file-list="codeImgs"
						:data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">兼职码</Button>
					</Upload>
				</FormItem>
				<FormItem label="启用验证" prop="sortIndex">
					<i-switch v-model="addForm.valid=='1'" size="large" @on-change="changeValid($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
				<template v-if="addForm.valid=='1'">
					<FormItem>
						<Row>
							<Col span="5">
							提示内容
							</Col>
							<Col span="19">
							<Input v-model="addForm.validConfig.titleMsg" type="textarea" />
							</Col>

						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col span="5">
							<Checkbox v-model="addForm.validConfig.useAge">年龄范围</Checkbox>
							</Col>
							<template v-if="addForm.validConfig.useAge">
								<Col span="9"><Input v-model="addForm.validConfig.minAge" type="number"></Input></Col>
								<Col span="1" style="text-align: center;">-</Col>
								<Col span="9"><Input v-model="addForm.validConfig.maxAge" type="number"></Input></Col>
								<Col span="5">拒绝提示</Input></Col>
								<Col span="19"><Input v-model="addForm.validConfig.ageMsg"></Input></Col>
							</template>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col span="5">
							<Checkbox v-model="addForm.validConfig.useSex">性别</Checkbox>
							</Col>
							<template v-if="addForm.validConfig.useSex">
								<Col span="19">
								<RadioGroup v-model="addForm.validConfig.sex">
									<Radio label="男">男</Radio>
									<Radio label="女">女</Radio>
								</RadioGroup>
								</Col>
								<Col span="5">拒绝提示</Input></Col>
								<Col span="19"><Input v-model="addForm.validConfig.sexMsg"></Input></Col>
							</template>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col span="5">
							<Checkbox v-model="addForm.validConfig.useEducation">最低学历</Checkbox>
							</Col>
							<template v-if="addForm.validConfig.useEducation">
								<Col span="19">
								<RadioGroup v-model="addForm.validConfig.education">
									<Radio label="初中">初中</Radio>
									<Radio label="高中/中专">高中/中专</Radio>
									<Radio label="专科/大学">专科/大学</Radio>
									<Radio label="硕士">硕士</Radio>
									<Radio label="博士">博士</Radio>
								</RadioGroup>
								</Col>
								<Col span="5">拒绝提示</Input></Col>
								<Col span="19"><Input v-model="addForm.validConfig.educationMsg"></Input></Col>
							</template>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col span="5">
							<Checkbox v-model="addForm.validConfig.useGraduate">是否毕业</Checkbox>
							</Col>
							<template v-if="addForm.validConfig.useGraduate">
								<Col span="19">
								<RadioGroup v-model="addForm.validConfig.graduate">
									<Radio label="1">是</Radio>
									<Radio label="0">否</Radio>
								</RadioGroup>
								</Col>
								<Col span="5">拒绝提示</Input></Col>
								<Col span="19"><Input v-model="addForm.validConfig.graduateMsg"></Input></Col>
							</template>
						</Row>
					</FormItem>
				</template>
				<FormItem label="排序" prop="sortIndex">
					<Input v-model="addForm.sortIndex" type="number" placeholder="数字越大越靠前"></Input>
				</FormItem>
				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status=='1'" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>

			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateLight">确认提交</Button>
			</div>
		</Modal>

		<Modal v-model="dateSetShow" title="日期设置" width="300">
			<DatePicker type="date" v-model="recordDate" format="yyyy/MM/dd" placement="bottom-end" placeholder="请选择"
				clearable />
			<div slot="footer">
				<Button type="primary" @click="dateSetSure">确认</Button>
			</div>
		</Modal>
		<Modal v-model="appChannelShow" title="渠道兼职配置" width="650" @on-ok="appChannelConfig">
			<Table stripe :columns="appChannelCols" :data="appChannels" height="400">
				<template slot-scope="{ row, index }" slot="onlineShop">
					<i-switch v-model="appChannels[index].onlineShop" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="shop">
					<i-switch v-model="appChannels[index].shop" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="videoShop">
					<i-switch v-model="appChannels[index].videoShop" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="online">
					<i-switch v-model="appChannels[index].online" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="liver">
					<i-switch v-model="appChannels[index].liver" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="videoSale">
					<i-switch v-model="appChannels[index].videoSale" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="group">
					<i-switch v-model="appChannels[index].group" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
				<template slot-scope="{ row, index }" slot="self">
					<i-switch v-model="appChannels[index].self" size="large">
						<span slot="open">显示</span>
						<span slot="close">隐藏</span>
					</i-switch>
				</template>
			</Table>

		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition11'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				importCompany: api.statistics.importJob,
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					scene: undefined,
					attr: undefined,
					city: '',
					title: '',
					education: '',
					company: '',
					companyType: '',
					jobTag: '',
					recommendType: '',
					dataType: '',
					jobDesc: '',
					salary: 0,
					jobLimit: '',
					settleType: undefined,
					codeUrl: '',
					status: '1',
					sortIndex: 0,
					valid: '0',
					validConfig: {
						titleMsg: '',
						useAge: false,
						minAge: undefined,
						maxAge: undefined,
						ageMsg: "",

						useSex: false,
						sex: undefined,
						sexMsg: "",

						useEducation: false,
						education: undefined,
						educationMsg: "",

						useGraduate: false,
						graduate: undefined,
						graduateMsg: "",
					}
				},
				addRule: {

				},
				dateSetShow: false,
				dateSetId: undefined,
				recordDate: undefined,
				appChannelShow: false,
				appChannels: [],
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '排序',
						width: 60,
						key: 'sortIndex',
						align: 'center'
					},
					{
						title: '岗位ID',
						width: 150,
						key: 'id',
						align: 'center'
					},
					{
						title: '岗位类型',
						width: 150,
						key: 'jobTag',
						align: 'center'
					},
					{
						title: '兼职猫id',
						width: 300,
						key: 'partTimeId',
						align: 'center'
					},
					{
						title: '岗位名称',
						width: 300,
						key: 'title',
						align: 'center'
					},
					{
						title: '公司名称',
						key: 'company',
						align: 'center',
						width: 260,
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center',
						width: 200,
					}, {
						title: '推送日期',
						key: 'pushDate',
						align: 'center',
						width: 120,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			},
			appChannelCols() {
				return [{
						title: '渠道',
						width: 150,
						key: 'channel',
						align: 'center'
					}, {
						title: '网店',
						slot: 'onlineShop',
						width: 150,
						align: 'center'
					}, {
						title: '电商',
						slot: 'shop',
						width: 150,
						align: 'center'
					}, {
						title: '短视频带货',
						slot: 'videoShop',
						width: 150,
						align: 'center'
					}, {
						title: '短视频卖货',
						slot: 'videoSale',
						width: 150,
						align: 'center'
					}, {
						title: '线上兼职',
						slot: 'online',
						width: 150,
						align: 'center'
					}, {
						title: '主播',
						slot: 'liver',
						width: 150,
						align: 'center'
					}, {
						title: '瓷片区',
						slot: 'group',
						width: 150,
						align: 'center'
					}, {
						title: '自营区',
						slot: 'self',
						width: 150,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.jobMaoPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			codeImgBack(response, file, fileList) {
				this.addForm.codeUrl = response.data.url
				this.codeImgs = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			addOrUpdateLight() {
				const that = this
				api.statistics
					.addOrEditJob(this.addForm)
					.then(res => {
						that.initAdd()
						that.addJobShow = false
						that.refreshData()
					})
					.then(() => {
						that.loading = false
					})
			},
			changeValid(state, data) {
				this.addForm.valid = state ? '1' : '0'
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateStatus(id, status) {
				const that = this
				api.statistics
					.updateJobMaoStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(row) {
				const that = this
				api.statistics
					.jobDetail(row.id)
					.then(res => {
						const result = res.data || {}
						that.addForm = {
							...that.addForm,
							...result
						}
						if (result.validJson) {
							that.addForm.validConfig = JSON.parse(result.validJson)
						}
						that.codeImgs = [{
							name: result.codeUrl,
							url: result.codeUrl
						}];

						that.addJobShow = true
					})
			},

			initAdd() {
				this.codeImgs = [];
				this.addForm = {
					id: undefined,
					scene: undefined,
					attr: undefined,
					city: '',
					title: '',
					education: '',
					company: '',
					companyType: '',
					jobTag: '',
					recommendType: '',
					dataType: '',
					jobDesc: '',
					salary: 0,
					jobLimit: '',
					settleType: undefined,
					codeUrl: '',
					status: '1',
					sortIndex: 0,
					valid: '0',
					validConfig: {
						titleMsg: '',
						useAge: false,
						minAge: undefined,
						maxAge: undefined,
						ageMsg: "",

						useSex: false,
						sex: undefined,
						sexMsg: "",

						useEducation: false,
						education: undefined,
						educationMsg: "",

						useGraduate: false,
						graduate: undefined,
						graduateMsg: "",
					}
				}
			},
			dateSet(row) {
				this.dateSetShow = true
				this.dateSetId = row.id
			},
			dateSetSure() {
				const that = this
				const param = {
					"id": this.dateSetId,
					"pushDate": this.util.getUTCTime('yyyy-MM-dd', this.recordDate)
				}
				api.statistics
					.jobPushDateSet(param)
					.then(res => {
						that.dateSetShow = false
						that.refreshData()
					})
			},
			appChannelConfigShow() {
				const queryParams = {
					page: 1,
					limit: 100
				}
				//获取全部应用市场
				api.statistics
					.getStorePage(queryParams)
					.then(res => {
						const result = res.data || {}
						const allApp = result.records
						//获取渠道配置
						api.statistics
							.getAppChannelSwitch()
							.then(res => {
								let result = res.data || []
								let appCodes = []
								for (var i = 0; i < result.length; i++) {
									appCodes[i] = result[i].channel
								}
								allApp.forEach(function(obj) {
									if (appCodes.indexOf(obj.storeCode) < 0) {
										result.push({
											channel: obj.storeCode,
											onlineShop: true,
											shop: true,
											videoShop: true,
											online: true,
											liver: true,
											group: true,
											self: true,
											videoSale: true,
										})
									}
								});
								this.appChannels = result
								this.appChannelShow = true
							})
					})
					.catch(err => {
						this.$Message.error('获取应用市场列表失败: ' + err.message)
					})
			},
			appChannelConfig() {
				api.statistics
					.appChannelSwitchConfig({
						appChannelSwitches: this.appChannels
					})
					.then(res => {
						this.appChannelShow = false
					})
			},
			//导出数据
			exportExcel() {
				const that = this
				const queryParams = {
					page: 1,
					limit: 10,
					...this.queryParams
				}
				api.statistics
					.exportJob(queryParams)
					.then(res => {
						that.util.excel(res, "报名数据")
					})
			},
			/** 下载模板操作 */
			importTemplate() {
				const that = this
				api.statistics.importJobTemplate().then(res => {
					that.util.excel(res, "导入兼职猫岗位模板")
				});
			},
		}

	}
</script>